import i18next from 'i18next';
import { initReactI18next } from "react-i18next";

i18next
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    targetSelectTitle: 'Preset Manager',
                    targetSelectDescription: "This is preset management tool for MOTOR SYNTH (MKI and MKII). You can use this tool if you have Motor Synth MKI and wish to keep working presets on your Motor Synth MKI following the v1.2 update (select target MKI v1.2+).",
                    converterInstructionsTitle: 'Instructions',
                    converterInstructionLines: [
                      'Drag and drop presets to reorder them within a bank or to move them to another bank',
                      'Drag and drop banks to change their order',
                      'Preset and bank numbers will change automatically',
                      'Click on a bank or preset name to rename it',
                    ],
                    mk1SpecificInstruction: 'Uploaded legacy presets (ones saved with MS MK1 firmware version v1.2 or earlier) are converted to be compatible with MS MK1 v1.2+ prior to downloading',
                    browse: "Browse",
                    clear: "Clear",
                    download: "Download",
                    convertAndDownload: "Convert & Download",
                    loadGcaPresets: "Load GCA Presets",
                    mergeGcaPresets: "Merge with Newest GCA Presets",
                    dropAreaTitle: "Drag and drop your MS presets (.zip or .mspr files) here",
                    or: 'or',
                    loading: 'Loading...',
                    hideEmptyBanks: "Hide empty banks",
                    banks: 'Banks',
                    presetsSkippedError: "{{ presetCount }} presets were skipped, due to being incompatible with {{ target }}",
                    emptyPlaceholder: '<EMPTY>',
                    untitledPlaceholder: '<UNTITLED>',
                },
            },
            lv: {
                translation: {
                    targetSelectTitle: 'Presetu pārvaldības rīks',
                    targetSelectDescription: "Šis ir MOTOR SYNTH (MKI un MKII) presetu pārvaldības rīks. Jūs varat izmantot šo rīku, ja jums ir Motor Synth MKI un vēlaties turpināt darboties ar presetiem pēc v1.2 atjauninājuma (izvēlieties MKI v1.2+).",
                    converterInstructionsTitle: 'Instrukcijas',
                    converterInstructionLines: [
                      'Velciet un nometiet presetus, lai tos pārkārtotu bankā vai nometiet citā bankā',
                      'Velciet un nometiet bankas, lai tos pārkārtotu',
                      'Presetu un banku numuri tiks mainīti automātiski',
                      'Noklikšķiniet uz bankas vai presetu nosaukuma, lai to pārdēvētu',
                    ],
                    mk1SpecificInstruction: 'Augšupielādētie vecie preseti (tas, kas saglabāti ar MS MK1 firmvērsumu v1.2 vai agrāk) tiek konvertēti, lai būtu saderīgi ar MS MK1 v1.2+, pirms lejupielādes',
                    browse: "Pārlūkot",
                    clear: "Notīrīt",
                    download: "Lejupielādēt",
                    convertAndDownload: "Konvertēt & Lejupielādēt",
                    loadGcaPresets: "Ielādēt GCA Presetus",
                    mergeGcaPresets: "Apvienot ar jaunākajiem GCA Presetiem",
                    dropAreaTitle: "Velc un nomet savus MS presetus (kā .zip vai .mspr failus) šeit",
                    or: 'vai',
                    loading: 'Ielādē...',
                    banks: 'Bankas',
                    hideEmptyBanks: "Paslēpt tukšās bankas",
                    presetsSkippedError: "{{ presetCount }} preseti tika izlaisti, jo tika konstatēts, ka tie nav saderīgi ar {{ target }}",
                    emptyPlaceholder: '<TUKŠS>',
                    untitledPlaceholder: '<BEZ NOSAUKUMA>',
                },
            },
            jp: {
                translation: {
                    targetSelectTitle: 'プリセットマネージャー',
                    targetSelectDescription: "これは、MOTOR SYNTH（MKIおよびMKII）のプリセット管理ツールです。あなたがMotor Synth MKIを持っていて、v1.2アップデート後にMotor Synth MKIで作業を続けたい場合は、このツールを使用できます（ターゲットをMKI v1.2+に選択してください）",
                    converterInstructionsTitle: '説明',
                    converterInstructionLines: [
                      'プリセットをドラッグ＆ドロップして、バンク内で並べ替えるか、別のバンクにドロップします',
                      'バンクをドラッグ＆ドロップして、順序を変更します',
                      'プリセットとバンク番号は自動的に変更されます',
                      'バンクまたはプリセット名をクリックして、名前を変更します',
                    ],
                    mk1SpecificInstruction: 'アップロードされたレガシープリセット（v1.2以前のMS MK1ファームウェアバージョンで保存されたプリセット）は、ダウンロードする前にMS MK1 v1.2+と互換性のあるように変換されます',
                    browse: "ブラウズ",
                    clear: "クリア",
                    download: "ダウンロード",
                    convertAndDownload: "変換してダウンロード",
                    loadGcaPresets: "GCAプリセットを読み込む",
                    mergeGcaPresets: "最新のGCAプリセットとマージ",
                    dropAreaTitle: "ここに MS プリセット（.zip または .mspr ファイル）をドラッグ＆ドロップしてください",
                    or: 'または',
                    loading: '読み込み中...',
                    hideEmptyBanks: "空のバンクを非表示にする",
                    banks: 'バンク',
                    presetsSkippedError: "{{ target }}と互換性のない{{ presetCount }}のプリセットがスキップされました",
                    emptyPlaceholder: '<空>',
                    untitledPlaceholder: '<タイトルなし>',
                },
            }
        },
        lng: "en",
        fallbackLng: "en",
        // Disable i18next's default escaping, which prevents XSS
        // attacks. React already takes care of this.
        interpolation: {
            escapeValue: false,
        }
    });

export default i18next;